<div class="container h-100 align-items-center canvas-page">
  <div *ngIf="isLoading" class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5" *ngIf="isLoading == false">
    <div class="card RegularForm rounded col-12 col-xs-9 col-lg-8 canvas-panel"
      [class.SmallArabicFont]="globalService.isRTL == true">
      <div class="card-body MyCardBody rounded-bottom">
        <app-empty-state *ngIf="!hasVisibleGroups && InvitationCount() === 0" kind="groups"></app-empty-state>
        <div class="mb-1 col form-group text-primary text-center" style="margin-bottom: 0px"
          *ngIf="InvitationCount() > 0">
          <br />
          <div class="alert alert-primary mx-3" style="margin-bottom: 1px" role="alert">
            <span> {{ globalService.Get("INVITATIONS") }} ({{ InvitationCount() }}) </span>
          </div>
        </div>
        <div *ngIf="InvitationCount() > 0 && groupId == 0" class="mx-2">
          <div *ngFor="let invitation of invitations; let index = index">
            <div class="row form-group newSelect mx-4" *ngIf="invitation['resolved'] == false">
              <div class="col form-group text-center text-dark">
                <div class="m-2">
                  {{ invitation.memberName }}, {{ globalService.Get("YOUR_INVITED_TO_JOIN") }}
                </div>
                <div>
                  <span class="text-dark px-2">
                    {{ 'GROUP_VALUE0' | translate:{value0:(invitation.groupName)} }}</span>
                </div>
                <div *ngIf="
                  invitation.description != null &&
                  invitation.description.trim() != ''
                ">
                  <small>{{ invitation.description }} </small>
                </div>
                <div *ngIf="
                  invitation.mission != null && invitation.mission.trim() != ''
                ">
                  <small>{{ invitation.mission }} </small>
                </div>
                <div>
                  <img *ngIf="
                    invitation.presignedUrl != '' &&
                    invitation.presignedUrl != null
                  " [src]="invitation.presignedUrl" class="img-fluid fitimage m-2" style="max-width: 150px" />
                </div>
                <div class="mt-3">
                  <button class="btn btn-primary btn-small m-1" (click)="Accept(invitation)" type="button">
                    <i class="fas fa-spinner fa-spin" *ngIf="invitation.process == true"></i>
                    <small *ngIf="!invitation.process"> {{ globalService.Get("ACCEPT") }}</small>
                  </button>
                  <button class="btn btn-danger btn-small m-1" (click)="Reject(invitation)" type="button">
                    <small> {{ globalService.Get("REJECT") }}</small>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="mb-2 col form-group text-primary text-center" style="margin-bottom: 0px"
          *ngIf="groupsArr.length > 0">
          <div class="alert alert-primary mx-3" style="margin-bottom: 3px" role="alert" *ngIf="groupId == 0">
            <span> {{ globalService.Get("MY_GROUPS") }} </span>
          </div>
        </div>
        <div *ngFor="let group of groupsArr; let index = index">
          <div class="entity-list-item" *ngIf="
            group.members.length > 0 &&
            (groupId == 0 || groupId == group.groupId)
          ">
            <div class="row">
              <div class="col form-group text-center mx-3 my-1">
                <div>
                  <button class="btn btn-primary btn-block py-2 active" (click)="group.expanded = !group.expanded"
                    type="button">
                    <div>{{ group.groupName }}</div>
                  </button>
                </div>
              </div>
            </div>
            <div class="col form-group text-center text-primary"
              [style.display]="group.expanded == true ? 'block' : 'none'">
              <div class="editSelect">
                <br>
                <div class="text-dark">
                  {{ globalService.Get("HOUSEHOLD_MEMBERS") }} ({{ group.members.length }})
                  <div *ngIf="
                    group.description != null && group.description.trim() != ''
                  ">
                    <small>{{ group.description }} </small>
                  </div>
                  <div *ngIf="group.mission != null && group.mission.trim() != ''">
                    <small>{{ group.mission }} </small>
                  </div>
                </div>
                <img *ngIf="group.presignedUrl != '' && group.presignedUrl != null" [src]="group.presignedUrl"
                  class="img-fluid fitimage mb-4" style="max-width: 150px" />
                <div *ngFor="let member of group.members; let mindex = index">
                  <div class="m-2" *ngIf="member['leave'] == null || member['leave'] == false">

                    <div class="col-12 text-dark mt-2 text-center">
                      {{ member.firstName }}
                    </div>
                    <!-- Detailed Points -->
                    <ng-container *ngFor="let detail of member.detailedPoints">
                      <div *ngIf="detail.points > 0" class="d-flex justify-content-between align-items-center mx-auto"
                        style="max-width: 250px;">
                        <div class="text-dark text-start">
                          {{ detail.systemName.replace("Points System", "") }}
                        </div>

                        <!-- Points -->
                        <div class="text-dark text-end">
                          {{ detail.points }}
                          <i class="fas fa-star text-danger"></i>
                        </div>
                      </div>
                    </ng-container>
                    <app-list-actions *ngIf="member.allowAccess == true">
                      <div listPrimaryAction class="col-6 text-center">
                        <button class="btn btn-primary btn-small" (click)="OpenPoints(member.memberId)"
                          type="button">
                          <small> {{ globalService.Get("EDIT_POINTS") }}</small>
                        </button>
                      </div>
                      <div class="col-6 text-center">
                        <button class="btn btn-primary btn-small" (click)="member['leave'] = true"
                          [disabled]="group.canLeave == false" type="button">
                          <small> {{ globalService.Get("LEAVE_GROUP") }}</small>
                        </button>
                      </div>
                    </app-list-actions>
                    <div>
                      <div class="col-12 text-center" *ngIf="member.allowAccess == false">
                        <button class="btn btn-primary mt-2 btn-small" (click)="member['leave'] = true"
                          [disabled]="group.canLeave == false" type="button">
                          <small> {{ globalService.Get("LEAVE_GROUP") }}</small>
                        </button>
                      </div>
                    </div>
                    <div class="mx-2" *ngIf="member['leave'] == true">
                      <div class="row form-group">
                        <div class="col-12 text-center text-dark mt-2">
                          {{ member.firstName + " - " + globalService.Get("LEAVE_GROUP?") }}
                        </div>
                        <div class="col-12 text-center mt-3">
                          <button class="btn btn-danger btn-small mr-2" (click)="
                          LeaveGroup(
                            index,
                            mindex,
                            group.groupId,
                            member.memberId
                          )
                        " [disabled]="group.canLeave == false" type="button">
                            <i class="fas fa-spinner fa-spin" *ngIf="member.process == true"></i>
                            <small *ngIf="!member.process"> {{ globalService.Get("YES") }} </small>
                          </button>
                          <button class="btn btn-secondary btn-small" (click)="member['leave'] = false"
                            [disabled]="group.canLeave == false" type="button">
                            <small> {{ globalService.Get("NO") }} </small>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br>
                </div>
                <div class="p-2 ml-auto" *ngIf="group.displayMembers == true">
                  <button class="btn btn-secondary btn-block btn-small" (click)="browseMembers(group.groupId)"
                    type="button">
                    <span>
                      {{ globalService.Get("OPEN_GROUP") }}
                      <i class="fas fa-book"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col form-group text-primary text-center" style="margin-bottom: 5px" *ngIf="pubGroupsArr.length > 0">
          <div class="alert alert-primary mx-3" style="margin-bottom: 3px" role="alert" *ngIf="groupId == 0">
            <span> {{ globalService.Get("JOIN_NEW_GROUP?") }} </span>
          </div>
        </div>
        <div *ngFor="let pGroup of pubGroupsArr; let pIndex = index">
          <div class="entity-list-item" *ngIf="
            pGroup.members.length > 0 &&
            (groupId == 0 || groupId == pGroup.groupId)
          ">
            <div class="row">
              <div class="col form-group text-center mx-3 my-2">
                <div>
                  <button class="btn btn-primary btn-block py-2 active" (click)="pGroup.expanded = !pGroup.expanded"
                    type="button">
                    <div>{{ pGroup.groupName }}</div>
                  </button>
                </div>
              </div>
            </div>
            <div class="col form-group text-center text-primary"
              [style.display]="pGroup.expanded == true ? 'block' : 'none'">
              <div class="newSelect">
                <div class="text-dark">

                  <div *ngIf="
                    pGroup.description != null &&
                    pGroup.description.trim() != ''
                  ">
                    <small>{{ pGroup.description }} </small>
                  </div>
                  <div *ngIf="pGroup.mission != null && pGroup.mission.trim() != ''">
                    <small>{{ pGroup.mission }} </small>
                  </div>
                </div>
                <img *ngIf="pGroup.presignedUrl != '' && pGroup.presignedUrl != null" [src]="pGroup.presignedUrl"
                  class="profileImage fitimage mb-4" style="max-width: 150px" />
                <div *ngFor="let member of pGroup.members; let mindex = index">
                  <div class="m-2" *ngIf="member['join'] == null || member['join'] == false">
                    <div class="row">
                      <div class="col-6 text-dark mt-2" [class.text-right]="globalService.isRTL == false"
                        [class.text-left]="globalService.isRTL == true">
                        {{ member.firstName }}
                      </div>
                      <div class="col-6" *ngIf="member['requested'] == false"
                        [class.text-right]="globalService.isRTL == true"
                        [class.text-left]="globalService.isRTL == false">
                        <button class="btn btn-primary btn-small" (click)="member['join'] = true" type="button">
                          <small> {{ globalService.Get("JOIN") }} </small>
                        </button>
                      </div>
                      <div class="col-6 text-left" *ngIf="member['requested'] == true">
                        <button class="btn btn-secondary btn-small" type="button" [disabled]="true">
                          <small> {{ globalService.Get("REQUESTED") }}</small>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mx-2" *ngIf="
                    member['join'] == true && pGroup.requestWorkflow == false
                  ">
                    <div class="row form-group">
                      <div class="col-12 text-center text-dark mt-2">
                        {{ member.firstName }} - {{ globalService.Get("JOIN?") }}
                      </div>
                      <div class="col-12 text-center mt-3">
                        <button class="btn btn-danger btn-small mr-2" (click)="
                          JoinGroup(
                            pIndex,
                            mindex,
                            pGroup.groupId,
                            member.memberId
                          )
                        " type="button">
                          <i class="fas fa-spinner fa-spin" *ngIf="member.process == true"></i>
                          <small *ngIf="!member.process"> {{ globalService.Get("YES") }} </small>
                        </button>
                        <button class="btn btn-secondary btn-small" (click)="member['join'] = false" type="button">
                          <small> {{ globalService.Get("NO") }} </small>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mx-2" *ngIf="
                    member['join'] == true &&
                    pGroup.requestWorkflow == true &&
                    (pGroup.requestQuestion == null ||
                      pGroup.requestQuestion.trim() == '')
                  ">
                    <div class="row form-group">
                      <div class="col-12 text-center text-dark mt-2">
                        {{ member.firstName }} - {{ globalService.Get("JOIN?") }}
                      </div>
                      <div class="col-12 text-center mt-3">
                        <button class="btn btn-danger btn-small mr-2" (click)="
                          RequestGroup(
                            pIndex,
                            mindex,
                            pGroup.groupId,
                            member.memberId
                          )
                        " type="button">
                          <i class="fas fa-spinner fa-spin" *ngIf="member.process == true"></i>
                          <small *ngIf="!member.process"> {{ globalService.Get("YES") }} </small>
                        </button>
                        <button class="btn btn-secondary btn-small" (click)="member['join'] = false" type="button">
                          <small> {{ globalService.Get("NO") }} </small>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mx-2" *ngIf="
                    member['join'] == true &&
                    pGroup.requestWorkflow == true &&
                    pGroup.requestQuestion != null &&
                    pGroup.requestQuestion.trim() != ''
                  ">
                    <div class="row form-group">
                      <div class="col-12 text-center text-dark mt-2 mb-3">
                        {{ member.firstName }} {{ globalService.Get("PLEASE_ANSWER") }}
                        <br />
                        {{ pGroup.requestQuestion.trim() }}
                        <br /><br />
                        <textarea class="form-control" [(ngModel)]="member.answer" cols="40" rows="5"></textarea>
                      </div>
                      <div class="col-12 text-center">
                        <button class="btn btn-danger btn-small mr-2" (click)="
                          RequestGroup(
                            pIndex,
                            mindex,
                            pGroup.groupId,
                            member.memberId
                          )
                        " type="button">
                          <i class="fas fa-spinner fa-spin" *ngIf="member.process == true"></i>
                          <small *ngIf="!member.process"> {{ globalService.Get("SUBMIT") }} </small>
                        </button>
                        <button class="btn btn-secondary btn-small" (click)="member['join'] = false" type="button">
                          <small> {{ globalService.Get("CANCEL") }} </small>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
